import React from 'react';

/*
 * stat cards row. Props-only. cards: [{ label, value, chip, tone: 'brand'|'pos'|'neg'|undefined }]
 */
// The brand tile spans two cells; --tp-cells lets the grid fit every tile on one row when it can.
const cell_count = (cards) => cards.length + cards.filter((c) => c.tone === 'brand').length;

const SummaryCards = ({ cards }) => (
  <div className="tp-stats tp-stats-fit" style={{ '--tp-cells': cell_count(cards) }}>
    {cards.map((c) => (
      <div key={c.label} className={`tp-stat ${c.tone === 'brand' ? 'tp-stat-brand' : ''}`}>
        <div className="tp-stat-label">{c.label}</div>
        <div
          className="tp-stat-value"
          style={
            c.tone === 'pos'
              ? { color: 'var(--state-success)' }
              : c.tone === 'neg'
                ? { color: 'var(--state-error)' }
                : undefined
          }
        >
          {c.value}
        </div>
        {c.chip ? <span className="tp-stat-chip">{c.chip}</span> : null}
      </div>
    ))}
  </div>
);

export default SummaryCards;
